import React, {useEffect, useState} from 'react';
import Grid from "@material-ui/core/Grid";
import {DropzoneAreaBase} from "material-ui-dropzone";
import makeStyles from "@material-ui/core/styles/makeStyles.js";
import {Button} from "@material-ui/core";
import {useDispatch, useSelector} from "react-redux";
import {getActiveEnvironmentState, loadingActiveEnvironmentState} from "../../redux/reducers/master-of-acts-reducer.js";
import {useParams} from "react-router-dom";
import {
    downloadWordTemplate,
    getWordTemplate,
    selectWordTemplate, uploadWordTemplate
} from "../../redux/reducers/word-template-edit-reducer.js";

const useStyles = makeStyles((theme) => (
    {
        root: {
            padding: theme.spacing(2),
            height: '100%'
        },
        dropzoneGrid: {
            flex: 1
        },
        previewChip: {
            minWidth: 160,
            maxWidth: 210
        }
    }
))

const WordTemplateUploadContainer = () => {
    const {projectID} = useParams()

    const [files, setFiles] = useState([])

    const classes = useStyles()

    const dispatch = useDispatch()

    const environmentState = useSelector(getActiveEnvironmentState)
    const wordTemplate = useSelector(selectWordTemplate)

    const handleDownloadFile = async () => {
        dispatch(downloadWordTemplate(wordTemplate?.id))
    }

    const handleAddFile = async (newFiles) => {
        setFiles(newFiles)  
    }

    const handleDeleteFile = async () => {
        setFiles([])
    }

    const handleSubmitButtonClick = async () => {
        await dispatch(uploadWordTemplate(wordTemplate.id, projectID, files[0]))
        await dispatch(loadingActiveEnvironmentState(projectID))
    }

    useEffect(() => {
        if (projectID) {
            dispatch(loadingActiveEnvironmentState(projectID))
        }
    }, [dispatch])

    useEffect(() => {
        if (environmentState) {
            dispatch(getWordTemplate(environmentState.word_template))
        }
    }, [environmentState])

    useEffect(() => {
        if (wordTemplate.file){
            setFiles([wordTemplate])
        }
    }, [wordTemplate])

    return (
        <Grid container direction={'column'} className={classes.root}>
            <Grid item alignItems={'center'} className={classes.dropzoneGrid}>
                <DropzoneAreaBase
                    fileObjects={files}
                    maxFileSize={10000000}
                    filesLimit={1}
                    onAdd={handleAddFile}
                    onDelete={handleDeleteFile}
                    dropzoneText={'Нажмите на выделенную область или перетащите файлы для загрузки'}
                    getFileLimitExceedMessage={(filesLimit) => `Превышено максимально допустимое количество файлов. Разрешено только ${filesLimit} `}
                    getFileAddedMessage={(fileName) => `Файл ${fileName} успешно добавлен `}
                    getFileRemovedMessage={(fileName) => `Файл ${fileName} удален `}
                    getDropRejectMessage={(rejectedFile) => `Файл ${rejectedFile.name} был отклонен `}
                    showPreviews={true}
                    showPreviewsInDropzone={false}
                    useChipsForPreview
                    previewGridProps={{container: {spacing: 1, direction: 'row'}}}
                    previewChipProps={
                        {
                            classes: {
                                root: classes.previewChip,
                            },
                            onClick: handleDownloadFile,
                        }}
                    previewText="Загруженные файлы"
                />
            </Grid>
            <Grid item container justifyContent={'flex-end'}>
            

                <Button variant={'contained'} onClick={handleSubmitButtonClick}>
                    Сохранить
                </Button>
            </Grid>
        </Grid>
        
    );
};

export default WordTemplateUploadContainer;